/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-18 18:17:05
 */
import { getTenantId, getToken } from "../auth";
import { assembleWSUrl } from "../urlUtil";
import BaseClient, { ONE_WAY_SEND_OPTIONS } from "./baseClient";
import Order from "./order";

const MAIL_URL = "/message/ws";

class MailClient extends BaseClient {
  constructor(parameters) {
    const mailUrl = assembleWSUrl(MAIL_URL) + "?tId=" + getTenantId();
    super(mailUrl, getToken(), parameters);
  }

  send(name, data) {
    return this._send(new Order(name, data));
  }

  sendOneWay(name, data) {
    return this._send(new Order(name, data), ONE_WAY_SEND_OPTIONS);
  }
}

export default MailClient;
